<template>
    <div class="breadcrumb">
      <button class="breadcrumb__back-navigation" @click="goBack">
          <svg aria-hidden="true">
              <use :xlink:href="'#back-navigation'"></use>
          </svg>
      </button>
      <a
        v-if="firstCrumb"
        class="breadcrumb__product-type"
        :href="firstCrumb.url"
      >
        {{ firstCrumb.label }}
      </a>
      <a
        v-else-if="productTypeLink"
        class="breadcrumb__product-type"
        :href="productTypeLink"
      >
        {{ formattedProductType }} Clothing
      </a>
      <template v-for="(crumb, index) in breadcrumbs" :key="index">
        <span class="breadcrumb__separator">&nbsp;/ </span>
        <a class="breadcrumb__crumb" :href="crumb.url">{{ crumb.label }}</a>
      </template>
      <span class="breadcrumb__product">&nbsp;/ {{ product.title }}</span>
    </div>
  </template>
  
  <script setup>
  import { computed } from 'vue';

  const props = defineProps({
    product: {
      type: Object,
      required: true
    }
  });

  const allCrumbs = computed(() => props.product?.breadcrumbs || []);

  // A crumb flagged "Use as first breadcrumb" in the metafield replaces the
  // hard-coded program link. Only the first flagged crumb is used, so exactly
  // one first crumb ever renders.
  const firstCrumb = computed(() => allCrumbs.value.find((crumb) => crumb.is_first) || null);

  // Middle crumbs: everything except the one promoted to the first position.
  const breadcrumbs = computed(() =>
    allCrumbs.value.filter((crumb) => crumb !== firstCrumb.value)
  );
  
  const formattedProductType = computed(() => {
    const type = props.product?.type
    if (type === 'Unisex' || type === 'Gift Card') return 'All'
    if (type === 'Digital') return 'Personal Shopping Experience'
    return type
  });
  
  const productTypeLink = computed(() => {
    const type = props.product?.type
    if (type === 'Unisex' || type === 'Gift Card') {
      return '/collections/master-collection'
    } else if (type === 'Digital') {
      return '/collections/personal-shopping-experience'
    } else {
      return '/collections/' + (type || '').replace(/'/g, '').toLowerCase().replace(/\s+/g, '-')
    }
  });

  const goBack = () => {
    window.history.back();
  };
  </script>
